import React from 'react'
import TimelineItemSummary from '../calendar/TimelineItemSummary'

class TimelineSummaryHeader extends React.Component {
  constructor (props) {
    super (props)
    this.state = {
      showReadyToComplete: true
    }
  }

  timelineHeaderDate() {
    return moment(this.props.date).format("D MMMM YYYY")
  }

  timelineHeaderDay() {
    return !this.props.title ? moment(this.props.date).format(" - dddd") : ''
  }

  renderTimelineItemSummary() {
    return (
      <TimelineItemSummary
        timeline_events={this.props.timeline_events}
        show_hidden_tasks={this.props.show_hidden_tasks}
        show_essential_tasks={this.props.show_essential_tasks}
        show_recommended_tasks={this.props.show_recommended_tasks}
        show_information_only_tasks={this.props.show_information_only_tasks}
      />
    )
  }

  handleClick() {
    this.setState(prevState => {
      return {
        showReadyToComplete: !prevState.showReadyToComplete
      }
    }, () => { this.props.chevronArrow(this.state.showReadyToComplete) })
  }

  chevronArrow() {
    return this.state.showReadyToComplete ? "fa fa-caret-down" : "fa fa-caret-right"
  }

  renderTitle() {
    return (
      <div className='timeline-date'>
        { 
          this.props.title ? 
            <span className='timeline-header-date timeline-header-title' onClick={() => this.handleClick() }>
              <i className={this.chevronArrow()} style={{ marginRight:"5px" }}></i>
              { this.props.title }
            </span>
          :
            <span className='timeline-header-date'>
              { this.timelineHeaderDate() }
            </span>
        }
        <span className='timeline-header-day'>
          { this.timelineHeaderDay() }
        </span>
      </div>
    )
  }

  render() {
    return(
      <div className='timeline-header'>
        {this.renderTitle() }
        { this.renderTimelineItemSummary() }
      </div>
    )
  }
}

export default TimelineSummaryHeader
